// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/clients.details/portfolio/clientdetails.portfolio.scss
// module id = 1156
// module chunks = 0